import VendorNav from "../Homepage/Components/VendorNav";
import { LoginBackground } from "../../Constants/Backgrounds";

const VendorLoginRequired = () => {
    return (
        <div className="flex flex-col h-screen">
            <VendorNav navbarColor="#26051C" />
            <div
                className="w-full h-full flex justify-center "
                style={{
                    backgroundImage: `url(${LoginBackground})`,
                    backgroundSize: 'cover',
                    position: 'relative'
                }}
            >
                <div className="absolute inset-0 bg-black opacity-5 z-0" />
                <div className="sm:mt-12 w-full xs:w-[32rem] h-[16rem] bg-white flex flex-col z-50">
                    <div className="px-16 py-10">
                        <h2 className="mt-8 font-proximanova text-[26px] font-[600] text-[#505050] text-center"> You are not logged in</h2>
                        <p className="font-proximanova text-[18px] text-[#505050] text-center sm:text-left mb-0">Please log in to enter to the CharmHealthHub Vendor Portal to continue</p>
                    
                    </div>
                </div>
            </div>
        </div>
    );
}

export default VendorLoginRequired;